/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { containerStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { css } from "styled-components";

containerStyles.fulfillmentMethodAndNotesGridItem = {
    css: css`
        display: none;
    `,
};

containerStyles.approverInfoGridItem = {
    css: css`
        display: none;
    `,
};

containerStyles.notesAndCartTotalGridItem = {
    ...containerStyles.notesAndCartTotalGridItem,
    css: css`
        position: relative;
    `,
};

containerStyles.notesAndCartTotalContainer = {
    ...containerStyles.notesAndCartTotalContainer,
    gap: 10,
    css: css`
        position: sticky;
        top: 175px;
    `,
};

containerStyles.loadingOverlay = {};
